import { RootState } from '@src/redux/store'
import { prop } from 'ramda'
import { createSelector } from 'reselect'

import {
  GLOBAL_STATE,
  REPORT,
  REPORT_CREATE,
  REPORT_FIELDS,
  REPORT_FIELDS_FILTER,
  REPORT_LIST,
} from '../constants/actionTypes'

const reportsSelector = (state: RootState) => prop(GLOBAL_STATE, state)

export const reportListSelector = createSelector(reportsSelector, data => data[REPORT_LIST])

export const reportSelector = createSelector(reportsSelector, data => data[REPORT])

export const reportCreateSelector = createSelector(reportsSelector, data => data[REPORT_CREATE])

export const reportFieldsSelector = createSelector(reportsSelector, data => data[REPORT_FIELDS])

export const reportFieldsFilterSelector = createSelector(reportsSelector, data => data[REPORT_FIELDS_FILTER])
